import React from 'react';

const FeaturesSection = () => {
    return (
        <div id="features">
            <section class="gradient-bg text-white py-20 mt-16">
                <div class="container mx-auto px-4 text-center">
                    <h1 class="text-4xl md:text-6xl font-bold mb-6">Revolutionize Your Car Parts Inventory</h1>
                    <p class="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">AI-powered scanning solution for accurate and efficient car parts inventory management.</p>
                    {/* <button class="bg-white text-blue-600 px-8 py-3 rounded-lg font-bold text-lg hover:bg-blue-50 transition">
                Get Started
            </button> */}
                </div>
            </section>
            <section class="py-16 bg-white">
                <div class="container mx-auto px-4">
                    <h2 class="text-3xl font-bold text-center mb-12 text-gray-800">Powerful Features</h2>
                    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div class="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-md transition">
                            <div class="text-blue-600 mb-4">
                                <i class="fas fa-clipboard-list text-4xl"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-2 text-gray-800">Inventory Delivery Note Checks</h3>
                            <p class="text-gray-600">Automatically verify delivery notes against your inventory for accuracy.</p>
                        </div>
                        <div class="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-md transition">
                            <div class="text-blue-600 mb-4">
                                <i class="fas fa-brain text-4xl"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-2 text-gray-800">AI Scanner</h3>
                            <p class="text-gray-600">Advanced AI recognizes parts even without barcodes for comprehensive scanning.</p>
                        </div>
                        <div class="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-md transition">
                            <div class="text-blue-600 mb-4">
                                <i class="fas fa-barcode text-4xl"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-2 text-gray-800">Barcode Scanner</h3>
                            <p class="text-gray-600">Quickly scan barcodes for instant part identification and inventory updates.</p>
                        </div>
                        <div class="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-md transition">
                            <div class="text-blue-600 mb-4">
                                <i class="fas fa-chart-bar text-4xl"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-2 text-gray-800">Report Generation</h3>
                            <p class="text-gray-600">Generate detailed reports through the dashboard for analysis and record-keeping.</p>
                        </div>
                    </div>
                </div>
            </section></div>
    );
};

export default FeaturesSection;